import { render, staticRenderFns } from "./insertVipUser.vue?vue&type=template&id=35530876&"
import script from "./insertVipUser.vue?vue&type=script&lang=js&"
export * from "./insertVipUser.vue?vue&type=script&lang=js&"
import style0 from "./insertVipUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports